<script>
import { tableRelevant } from "@/pages/projectImpl/js/utils";
import SelectCourse from "@/components/course/SelectCourse.vue";
import ConfigClassTree from "./ConfigClassTree.vue";

export default {
  name: "TrainSet",
  components: { SelectCourse, ConfigClassTree },
  inject: {
    view: { default: false },
  },
  data() {
    return {
      columns: [
        { title: "机构名称", dataIndex: "organizationName" },
        { title: "训练名称", dataIndex: "courseName" },
        { title: "资源名称", dataIndex: "courseResourceName" },
        { title: "训练课时数", dataIndex: "trainingSessionCount" },
        { title: "学生数", scopedSlots: { customRender: "studentCount" } },
        { title: "操作", scopedSlots: { customRender: "action" } },
      ].filter(f => this.view ? f.title !== "操作" : true),
      table: tableRelevant.call(this),
      organizationId: undefined,
      organizationList: [],
      primaryData: {},
      addTrainModal: {
        visible: false,
        confirmLoading: false,
        selectData: [],
      },
      configClass: {
        visible: false,
        confirmLoading: false,
        info: {},
      },
    };
  },
  mounted() {
    this.getPageList();
  },
  methods: {
    selectCourseOK(arr) {
      const Params = {
        "id": this.$store.getters["organization/getReportInfo"].id,
        "organizationCourseId": arr[0].id,
      };
      this.addTrainModal.confirmLoading = true;
      this.$http.ReportService.GroupTrainingReportCourse(Params).then((res) => {
        this.getPageList();
        // 如果是新增的课程，则设置所有能力算分开关已勾选
        this.$store.commit("organization/setReportInfo", {
          ...this.$store.getters["organization/getReportInfo"],
          isAllChecked: true
        })
      }).finally(() => {
        this.addTrainModal.confirmLoading = false;
      });
    },
    getPageList() {
      this.table.tableLoading = true;
      this.$http.ReportService.GroupTrainingReportCourseConfig(this.$store.getters["organization/getReportInfo"].id, {message: false}).then((res) => {
        this.primaryData = res.data;
        this.table.tableDataSource = [res.data];
      }).catch(e => {
        this.primaryData = [];
        this.table.tableDataSource = [];
      }).finally(() => {
        this.table.tableLoading = false;
      });
    },
    deleteCourse(record) {
      this.table.tableLoading = true;
      this.$http.ReportService.GroupTrainingReportCourseDelete(this.$store.getters["organization/getReportInfo"].id).then((res) => {
        this.getPageList();
      }).finally(() => {
        this.table.tableLoading = false;
      });
    },
    tableConfig(record) {
      this.configClass.info = record;
      this.configClass.visible = true;
    },
    configClassOK(value) {
      const Params = {
        "id": this.$store.getters["organization/getReportInfo"].id,
        "classIds": value,
      };
      this.configClass.confirmLoading = true;
      this.$http.ReportService.GroupTrainingReportClass(Params).then((res) => {
        this.getPageList();
      }).finally(() => {
        this.configClass.confirmLoading = false;
      });
    },
  },
};
</script>

<template>
  <div>
    <div v-if="!view && !table.tableDataSource.length" class="header">
      <a-button @click="addTrainModal.visible = true" type="primary">添加训练</a-button>
    </div>
    <a-table :columns="columns"
             :rowKey="(text, index) => text.organizationName + index"
             :pagination="table.tablePagination"
             :loading="table.tableLoading"
             :dataSource="table.tableDataSource">
      <div slot="studentCount" slot-scope="text, record">
        {{ text.configuredClassStudentCount }} / {{ text.totalStudentCount }}
      </div>
      <div slot="action" slot-scope="text, record" class="operate">
        <a-button type="link" @click="tableConfig(record)">配置班级</a-button>

        <a-popconfirm title="确定删除？" @confirm="deleteCourse(record)">
          <a-button type="link" danger>删除</a-button>
        </a-popconfirm>
      </div>
    </a-table>
    <!-- 添加训练 -->
    <select-course title="添加训练课程" @ok="selectCourseOK" :confirmLoading="addTrainModal.confirmLoading"
                   :course-type="2" v-model="addTrainModal.visible" selectType="radio" />
    <config-class-tree v-model="configClass.visible" :info="configClass.info"
                       @ok="configClassOK" :confirmLoading="configClass.confirmLoading" />
  </div>
</template>

<style scoped lang="less">
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
}
</style>
